<div class="dark-view-holder">
  <div
    class="dark-view"
    (click)="closeBottomsheet()"
    id="bottomsheet-dark-view"
  ></div>
  <div class="bottomsheet-holder" id="reportBottomsheet">
    <div class="bottomsheet-first" id="bottomsheet-first">
      <div class="bottomsheet-title">
        <p>{{ data.firstTitle }}</p>
      </div>
      <div *ngIf="data.secondTitle !== ''" class="bottomsheet-mid-view">
        <p>{{ data.secondTitle }}</p>
      </div>
      <div
        *ngFor="let reason of data.optionsTitle; let i = index; let last = last"
      >
        <div
          class="bottomsheet-bot-view"
          [ngStyle]="{ 'border-bottom': last ? 'none' : '0.5px solid #e4e4e4' }"
          (click)="onClick(i)"
        >
          <p>{{ reason }}</p>
          <img src="assets/blog/left-arrow.png" />
        </div>
      </div>
    </div>
    <div class="bottomsheet-second" id="bottomsheet-second">
      <img src="assets/blog/report-completed.png" />
      <div class="completed-title">گزارش شما ثبت شد.</div>
      <div class="completed-description">
        ممنون از وقتی که گذاشتید. در اسرع وقت به گزارش شما رسیدگی میشه.
      </div>
    </div>
  </div>
</div>
